(() => {
  const setup = () => document.querySelectorAll('.g3d-buy-form').forEach(form => {
    const input = form.querySelector('[name="properties[Link NFC]"]');
    if (!input || form.dataset.nfcReady) return;
    form.dataset.nfcReady = 'true';
    const status = form.querySelector('.g3d-nfc-feedback');
    const button = form.querySelector('[name="add"]');
    const valid = () => {
      input.setCustomValidity('');
      const value = input.value.trim();
      let ok = false;
      try { const url = new URL(value); ok = ['https:', 'http:'].includes(url.protocol) && !!url.hostname && !/\s/.test(value); } catch {}
      if (!ok) input.setCustomValidity('Inserisci un link valido.');
      return ok;
    };
    input.addEventListener('input', valid);
    input.addEventListener('invalid', () => input.setCustomValidity('Inserisci un link valido.'));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!valid() || !form.reportValidity()) { input.reportValidity(); return; }
      if (form.closest('.g3d-configurator').dataset.nfcLoaded !== 'true' || button.disabled) return;
      input.value = input.value.trim();
      button.disabled = true;
      status.textContent = 'Aggiunta al carrello…';
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || 'Non è stato possibile aggiungere il portachiavi. Riprova.');
        if (item.properties?.['Link NFC'] !== input.value) throw new Error('Controlla il link NFC nel carrello prima di procedere.');
        status.replaceChildren(document.createTextNode('Portachiavi aggiunto al carrello. '));
        const link = document.createElement('a'); link.href = base + 'cart'; link.target = '_top'; link.textContent = 'Vai al carrello'; status.append(link);
        if (window.parent !== window) window.parent.postMessage({type:'g3d:nfc-added'}, location.origin);
      } catch(error) { status.textContent = error.message || 'Errore di connessione. Riprova.'; }
      finally { button.disabled = false; }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
